import { useIsAssetProviderIntegrationEnabled } from './useEnabledAssetsIntegrations';

export function useTenantHasEnabledAssetIntegration() {
  const { canConnectToIntegrations } = useIsAssetProviderIntegrationEnabled();
  return canConnectToIntegrations.length > 0;
}
